import React from 'react';
import './StatusItem.css';

function StatusItem({ success, name, value }) {
  const setSuccess = () => {
    switch (success) {
      case true:
        return '\u2713';
      case false:
        return '\u2717';
      default:
        return ``;
    }
  };

  return (
    <div>
      <b className="statusitem-name">{name}</b> {setSuccess()} {value}
    </div>
  );
}

export default StatusItem;